import { useQuery } from "@tanstack/react-query";
import { getLoginSecurity } from "@/api/monitor";
import { MonitorQueryKeys } from "./monitorQueryKeys";

// Locked / near-lock usernames and the last-24h failed sign-ins (Admin).
export const useLoginSecurity = () => {
  return useQuery({
    queryKey: [MonitorQueryKeys.LoginSecurity],
    refetchInterval: 30_000,
    queryFn: ({ signal }) => getLoginSecurity({ signal }),
  });
};
